import { OutlineBadgeColor } from "@app/shared/OutlineBadge";
import { QesColors } from "@app/shared/qes-standards/colors";
import { PgrConfidenceTierDefinition } from "@app/shared/confidence-tier/pgrConfidenceTierDefinition";

export const CONFIDENCE_TIER_FALLBACK_LABEL = "Insufficient Evidence";
export const CONFIDENCE_TIER_FALLBACK_BADGE_COLOR = OutlineBadgeColor.Gray;
export const CONFIDENCE_TIER_FALLBACK_PRIMARY_COLOR = QesColors.QesPrimaryGray5;

/** Filter value for providers with no Confidence Tier. */
export const CONFIDENCE_TIER_NO_DATA: number = null;
export const CONFIDENCE_TIER_NO_DATA_LABEL = "No Data";

/** Sorts tier selections, keeping "No Data" (null) apart from tier 0. */
export const compareConfidenceTierSelections = (a: number, b: number): number => (a ?? -1) - (b ?? -1);

const HEX_COLOR = /^#[0-9a-f]{3,8}$/i;
const OUTLINE_BADGE_COLORS = new Set<string>(Object.values(OutlineBadgeColor));

export const findTierByIndex = (
  definitions: PgrConfidenceTierDefinition[] | null | undefined,
  index: number | null | undefined,
): PgrConfidenceTierDefinition | undefined =>
  index != null && Number.isInteger(index) && index >= 0 ? definitions?.[index] : undefined;

/** Lower bounds are inclusive; expects the definitions highest confidence first. */
export const resolveTierForScore = (
  definitions: PgrConfidenceTierDefinition[] | null | undefined,
  score: number | null | undefined,
): PgrConfidenceTierDefinition | undefined =>
  score == null
    ? undefined
    : definitions?.find((definition) => definition.minimumScore == null || score >= definition.minimumScore);

export const resolveTierLabel = (label: string | null | undefined): string =>
  label?.trim() || CONFIDENCE_TIER_FALLBACK_LABEL;

export const resolveBadgeColor = (badgeColor: string | null | undefined): OutlineBadgeColor =>
  badgeColor != null && OUTLINE_BADGE_COLORS.has(badgeColor)
    ? badgeColor as OutlineBadgeColor
    : CONFIDENCE_TIER_FALLBACK_BADGE_COLOR;

/** Accepts a `#hex` value; anything else falls back to `qes-primary-gray-5`. */
export const resolvePrimaryColor = (primaryColor: string | null | undefined): string => {
  const value = primaryColor?.trim();
  return value && HEX_COLOR.test(value) ? value : CONFIDENCE_TIER_FALLBACK_PRIMARY_COLOR;
};
